import React from 'react';
import { BookOpen } from 'lucide-react';
import { useLanguage } from '../../i18n';
import { blogPosts } from '../../data/blogPosts';
import BlogCard from './BlogCard';

/**
 * 博客文章列表页面
 */
function BlogList() {
  const { language } = useLanguage();

  return (
    <div className="bg-[#faf9f6] dark:bg-gray-900">
      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* 页面标题 */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-3">
            <BookOpen size={28} className="text-indigo-600 dark:text-indigo-400" />
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              {language === 'zh' ? '博客' : 'Blog'}
            </h1>
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            {language === 'zh'
              ? '分享 JSON 工具使用技巧、开发经验和最佳实践'
              : 'Share JSON tool tips, development experience and best practices'}
          </p>
        </div>
        {/* 文章统计 */}
        <div className="mb-8">
          <p className="text-gray-600 dark:text-gray-400">
            {language === 'zh' ? '共' : 'Total'} {blogPosts.length} {language === 'zh' ? '篇文章' : 'articles'}
          </p>
        </div>

        {/* 文章列表 */}
        <div className="space-y-6">
          {blogPosts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>

        {/* 如果没有文章 */}
        {blogPosts.length === 0 && (
          <div className="text-center py-16">
            <BookOpen size={48} className="mx-auto text-gray-400 mb-4" />
            <p className="text-gray-500 dark:text-gray-400">
              {language === 'zh' ? '暂无文章' : 'No articles yet'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BlogList;
